export const COMPANIES_UPDATED_EVENT = 'kolin-companies-updated';

export const notifyCompaniesUpdated = () => {
  window.dispatchEvent(new CustomEvent(COMPANIES_UPDATED_EVENT));
};
